import { Position, State } from 'src/types'
import { positionChecker } from 'src/util/useModelDesign'
import { outfielderDefaultBackLace } from 'src/features/brands/dxm/canvas/rightThrow/glove/back/lace/outfielderDefaultBackLace'
import { beltBackStyleDrawerLeftThrow } from './beltBackstyle'
import { startInversion, undoInversion } from 'src/util/canvas'

export const backStyleOfGloveBackDrawerLeftThrow = (ctx: CanvasRenderingContext2D, state: State, position: Position, canvasWidth: number): void => {
  const needCatchFaceWrap = !state.baseModel?.isUBack || false
  // 通常ベルトモデル
  beltBackStyleDrawerLeftThrow(ctx, state, needCatchFaceWrap, canvasWidth)

  startInversion(ctx, canvasWidth)
  // 背面紐通し(外野手のみ)
  const { isOutfielder } = positionChecker(position)
  isOutfielder && outfielderDefaultBackLace(ctx, state.lace?.color)
  undoInversion(ctx, canvasWidth)
}
